import { lazy, Suspense } from "react";
import styled from "styled-components";
import { Routes, Route, Navigate } from "react-router-dom";
import LoadingSpinner from "./UI/LoadingSpinner";

const Login = lazy(() => import("./Routes/Login"));
const Home = lazy(() => import("./Routes/Home"));
const SignUp = lazy(() => import("./Routes/SignUp"));
const ConfirmSignUp = lazy(() => import("./Routes/ConfirmSignUp"));
const SmartMovieSuggestion = lazy(() => import("./Routes/SmartMovieSuggestion"));

const ContainerDiv = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #333333;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 6px;
    position: fixed;
  }
  ::-webkit-scrollbar-thumb {
    background: #454545;
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
const App = () => {
  return (
    <ContainerDiv id="mainContainer">
      <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/my-list" element={<Navigate to="/" replace state={{ view: "mylist" }} />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/confirm-sign-up" element={<ConfirmSignUp />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/smart-movie-suggestion"
          element={<SmartMovieSuggestion />}
        />
      </Routes>
      </Suspense>
    </ContainerDiv>
  );
};

export default App;
